import { useNavigate } from 'react-router-dom';

const useAddMember = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/profile?view=team');
  };

  return { handleClose };
};

export default useAddMember;
